var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5003 10.4998C20.5003 10.0396 20.8734 9.6665 21.3337 9.6665H25.5003C25.9606 9.6665 26.3337 10.0396 26.3337 10.4998V14.6665C26.3337 15.1267 25.9606 15.4998 25.5003 15.4998H21.3337C20.8734 15.4998 20.5003 15.1267 20.5003 14.6665V10.4998ZM22.167 11.3332V13.8332H24.667V11.3332H22.167Z",
    fill: "#014891"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5003 21.3332C20.5003 20.8729 20.8734 20.4998 21.3337 20.4998H25.5003C25.9606 20.4998 26.3337 20.8729 26.3337 21.3332V25.4998C26.3337 25.9601 25.9606 26.3332 25.5003 26.3332H21.3337C20.8734 26.3332 20.5003 25.9601 20.5003 25.4998V21.3332ZM24.667 22.1665H22.167V24.6665H24.667V22.1665Z",
    fill: "#014891"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 20.4998C10.0401 20.4998 9.66699 20.8729 9.66699 21.3332V25.4998C9.66699 25.9601 10.0401 26.3332 10.5003 26.3332H14.667C15.1272 26.3332 15.5003 25.9601 15.5003 25.4998V21.3332C15.5003 20.8729 15.1272 20.4998 14.667 20.4998H10.5003ZM11.3337 24.6665V22.1665H13.8337V24.6665H11.3337Z",
    fill: "#014891"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66699 10.4998C9.66699 10.0396 10.0401 9.6665 10.5003 9.6665H14.667C15.1272 9.6665 15.5003 10.0396 15.5003 10.4998V14.6665C15.5003 15.1267 15.1272 15.4998 14.667 15.4998H10.5003C10.0401 15.4998 9.66699 15.1267 9.66699 14.6665V10.4998ZM11.3337 11.3332V13.8332H13.8337V11.3332H11.3337Z",
    fill: "#014891"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 17.1665C10.8734 17.1665 10.5003 17.5396 10.5003 17.9998C10.5003 18.4601 10.8734 18.8332 11.3337 18.8332H17.167V20.9165C17.167 21.3767 17.5401 21.7498 18.0003 21.7498C18.4606 21.7498 18.8337 21.3767 18.8337 20.9165V18.8332H20.5003C20.9606 18.8332 21.3337 18.4601 21.3337 17.9998C21.3337 17.5396 20.9606 17.1665 20.5003 17.1665H18.8337V15.0832C18.8337 14.6229 18.4606 14.2498 18.0003 14.2498C17.5401 14.2498 17.167 14.6229 17.167 15.0832V17.1665H11.3337Z",
    fill: "#014891"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0003 17.9998C23.0003 17.5396 23.3734 17.1665 23.8337 17.1665H24.667C25.1272 17.1665 25.5003 17.5396 25.5003 17.9998C25.5003 18.4601 25.1272 18.8332 24.667 18.8332H23.8337C23.3734 18.8332 23.0003 18.4601 23.0003 17.9998Z",
    fill: "#014891"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8337 23.4165C18.8337 22.9563 18.4606 22.5832 18.0003 22.5832C17.5401 22.5832 17.167 22.9563 17.167 23.4165V24.2498C17.167 24.7101 17.5401 25.0832 18.0003 25.0832C18.4606 25.0832 18.8337 24.7101 18.8337 24.2498V23.4165Z",
    fill: "#014891"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8337 11.3332C18.8337 10.8729 18.4606 10.4998 18.0003 10.4998C17.5401 10.4998 17.167 10.8729 17.167 11.3332V12.1665C17.167 12.6267 17.5401 12.9998 18.0003 12.9998C18.4606 12.9998 18.8337 12.6267 18.8337 12.1665V11.3332Z",
    fill: "#014891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QR-Code.46e9c2f4ccc8a2cf0c5dc0c3ca29bbe4.svg";
export { ForwardRef as ReactComponent };